import React, { useEffect, useState } from "react";
import "@styles/components/ui/HealthBar.scss";

const HealthBar = ({
  value,
  max,
  maxColor = "#f5f5f5",
  valueColor = "#00e0a0",
  duration = 1000,
}) => {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  const [width, setWidth] = useState("0%");

  useEffect(() => {
    // 當 component mount / value 改變時，觸發動畫填滿
    const timeout = setTimeout(() => {
      setWidth(`${pct}%`);
    }, 50); // 延遲少少先有動畫效果
    return () => clearTimeout(timeout);
  }, [pct]);

  return (
    <div
      className="healthbar"
      style={{
        backgroundColor: maxColor,
        border: `2px solid ${valueColor}`,
      }}
    >
      <div
        className="healthbar-value"
        style={{
          width: width,
          backgroundColor: valueColor,
          transition: ` width ${duration}ms ease`,
        }}
      />
    </div>
  );
};

export default HealthBar;
